import { BiomeDensity } from './Planet.model';

export const DensityToSpreadRatio = {
  [BiomeDensity.Sparse]: 3,
  [BiomeDensity.Average]: 2,
  [BiomeDensity.Dense]: 1,
};
